import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Masks } from '@core/custom-validators/masks';
import { FieldConfig } from '../../models/field-config.interface';
import { CustomValidators } from '@core/custom-validators/validators';

@Component({
  selector: 'app-form-cnpj-caepf',
  templateUrl: './form-cnpj-caepf.component.html',
  styleUrls: ['./form-cnpj-caepf.component.scss']
})
export class FormCnpjCaepfComponent implements OnInit {

  formCNPJCAEPF: FormGroup;
  config: FieldConfig;
  group: FormGroup;
  mask = {
    mask: Masks.cnpjCaepf,
    guide: false,
    modelClean: true
  };
  firstSubmit = false;

  constructor(private formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.formCNPJCAEPF = this.formBuilder.group({
      cnpjCaepf: ['']
    })
    

    if (this.config.required) {
      this.cnpjCaepf.setValidators(Validators.compose([Validators.required, CustomValidators.cnpjCaepf]))
    }
    else
      this.cnpjCaepf.setValidators(Validators.compose([CustomValidators.cnpjCaepf]))

    this.group.statusChanges.subscribe((val) => {
      if (!this.firstSubmit) {
        this.firstSubmit = true;
        this.cnpjCaepf.setValue(this.cnpjCaepf.value);
      }
    })

    this.cnpjCaepf.valueChanges.subscribe((val) => {
      if (this.cnpjCaepf.valid) {
        this.control.setValue(this.clearMaskValue(val));
      }
      else {
        this.control.setValue(undefined);
      }
    })
  }

  get cnpjCaepf() {
    return this.formCNPJCAEPF.controls.cnpjCaepf;
  }

  get control() {
    return this.group.controls[this.config.name];
  }

  clearMaskValue(val): string {
    if (val)
      return val.replace(/[^\w\s]/gi, '');

    return val;
  }

}
